<template>
  <div class="py-10 px-24">
    <div class="bg-card bg-white dashboard-card card-shadow border-card-border">
      <div class="container md:px-12 pt-4 pb-6 flex flex-col items-center justify-center">
        <h1 class="text-center text-lg md:text-2xl font-semibold text-default pb-4">
          {{ this.header }}
        </h1>
        <h2 class="text-center md:px-20 text-md md:text-xl text-black-600" v-html="subheader" />
        <div class="flex flex-col mb-5 mt-5">
          How often do you receive a paycheck from your employer?
        </div>
        <Dropdown v-model="payrollFrequency" v-bind:dropdownOptions="payrollFrequencyList" :value="payrollFrequency"
          placeholder="Monthly" name="Payroll Frequency" type="text" class="mb-4 w-full md:w-1/2 px-2"
          @input="payrollFrequencyChanged" />
        <img alt="img" :src="this.image" class="md:w-1/3 my-10" />

        <base-button class="items-center m-auto justify-center" type="primary ml-auto" aria-label="navigate next"
          @click="handleClick" :disabled="argylePayload === ''">
          {{ this.buttonText }}
        </base-button>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from 'sweetalert2'
import Dropdown from '@/components/VIVA/Dropdown.vue'
import Vue from 'vue'
// import Swal from 'sweetalert2'
import gql from 'graphql-tag'

export default {
  name: 'DirectDeposit',
  components: {
    Dropdown
  },
  data: function () {
    return {
      showCallUsModal: false,
      payrollFrequencyList: ['Weekly', 'Twice a month', 'Monthly'],
      payrollFrequency: '',
      loading: false,
      exitedArgyle: false,
      close: false,
      step: 'landing',
      applyExtraPayment: true,
      argylePayload: '',
      argyleUserToken: ''
    }
  },
  computed: {
    ddSetUp() {
      return (
        this.$store.getters.offerStage === 'Paper Form Confirmation Pending' ||
        this.$store.getters.offerStage === 'Awaiting VIVA Signature' ||
        this.$store.getters.offerStage === 'Awaiting Borrower Signature'
      )
    },
    header() {
      return 'Set Up Repayment'
    },
    buttonText() {
      return 'Link Payroll'
    },
    subheader() {
      return 'Before we set up repayment, we will need to know a little bit more about your current employment.'
    },
    image() {
      return require('@/assets/img/sketches/wallet.svg')
    }
  },
  methods: {
    payrollFrequencyChanged() {
      this.argylePayload = ''
      this.initializeOneOffArgyle()
    },
    showCallUsPopup() {
      const image = require('@/assets/img/sketches/transferMoney.svg')
      Swal.fire({
        title: 'Uh-oh! It looks like there was a problem linking your payroll.',
        confirmButtonColor: '#69D393',
        html:
          '<div class=" pt-4 pb-6 flex flex-col items-center justify-center">' +
          '<p class="mb-2">' +
          'Not to worry! Please give us a call at <a class="font-bold" style="color:#559fe3" href="tel:678-685-8834">(678) 685-8834</a> and one of our agents will assist you.</p>' +
          `<img alt="img" src="${image}" class="md:w-1/2 my-4" />` +
          `</div>`,
        icon: '',
        confirmButtonText: 'Take me my dashboard'
      }).then(() => {
        this.$router.push({ name: 'Dashboard' })
      })
    },
    initializeOneOffArgyle() {
      const username = this.$store.state.user.signInUserSession.idToken.payload['cognito:username']
      // ['Weekly', 'Twice a month', 'Monthly']
      const frequency =
        this.payrollFrequency == 'Weekly' ? 4 : this.payrollFrequency == 'Monthly' ? 1 : 2
      const mutationStr = `mutation {initializeOneOffArgyle(username: "${username}", payFrequency: ${frequency}) {
        payload
        userToken
        linkFlowId
      }}`
      Vue.prototype.$apiClient
        .mutate({ mutation: gql(mutationStr) })
        .then(({ data }) => {
          console.log('argyle data', data)
          this.argylePayload = data.initializeOneOffArgyle.payload
          this.argyleUserToken = data.initializeOneOffArgyle.userToken
          this.argyleLinkFlowId = data.initializeOneOffArgyle.linkFlowId

        })
        .catch((e) => {
          console.log(e)
          console.log(`FE Error in initializeOneOffArgyle: ${e}`)
        })
    },
    handleClick() {
      this.argyle()
    },
    argyle() {
      // console.log(this.$store.state.argyleEmployerId)
      this.exitedArgyle = false
      this.close = false

      // ToDo: Use the link html provided by argyle docs
      const argyle = window.Argyle.create({
        userToken: this.$store.state.argyleUserToken,
        flowId: this.$store.state.argyleLinkFlowId,
        sandbox: this.$store.getters.isProduction ? false : true,
        linkKey: process.env.VUE_APP_LINK_KEY,
        ddsConfig: this.$store.state.argylePayload,
        ...(this.$store.state.argyleEmployerId
          ? { items: [this.$store.state.argyleEmployerId] }
          : {}),
        onAccountConnected: payload => console.log('account connected', payload),
        onDDSSuccess: payload => {
          console.log('Direct Deposit success', payload)

          this.step = 'submitted'
          this.$store.state.applicationData.offerStage = 'Paper Form Confirmation Pending'

          if (this.manualArgyleDDSetup) {
            this.$router.push({ name: 'MyLoan', query: this.$route.query })
          }

          if (this.$gtm.enabled() && window.dataLayer) {
            window.dataLayer.push({
              event: 'directDepositSetUp',
              stage: this.$store.getters.isProduction ? 'production' : 'dev',
              username: this.$store.getters.username,
              firstName: this.$store.getters.firstName,
              lastName: this.$store.getters.lastName,
              phoneNumber: this.$store.getters.phoneNumber,
              addrCountry: this.$store.getters.addrCountry,
              addrPostalCode: this.$store.getters.addrPostalCode
            })
          }
        },
        onDDSError: payload => console.warn('Direct Deposit error', payload),
        onError: ({ error }) => {
          if (error) {
            console.log('Error: ' + error)
            this.showCallUsPopup()
          }
        }
      })
      argyle.open()
    }
  }
}
</script>
